





























































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {Member, MemberInitState, MemberService, MemberServiceFreeTime,} from '@/store/member/member.types';
import {Service, ServiceInitState} from '@/store/service/service.types';
import {MemberServiceType} from '@/store/member/member.enum';
import {Toast} from '@/store/toast/toast.types';
import {ResponseCode} from '@/class/http';
import SelServiceComponent from '@/components/profile/SelService.vue';
import BgTheme1 from '@/components/bg-theme-1.vue';


@Component({
  components: {
    SelServiceComponent,
    BgTheme1
  }
})
export default class ServiceProviderComponent extends Vue {

  @State('member') memberInitState!: MemberInitState;
  @State('service') serviceState!: ServiceInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_getService', {namespace: 'service'}) getService!: () => Promise<void>;
  @Action('_getMemberById', {namespace: 'member'}) getMemberById!: (payload: string) => Promise<Member>;
  @Action('_deleteMemberService', {namespace: 'member'}) deleteMemberService!: (payload: string) => Promise<void>;
  @Action('_updateMemberServices', {namespace: 'member'}) updateMemberServices!: (payload: Member) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;

  public serviceList = [{id: ''}] as Service[];
  public MemberData = {} as Member;
  public getData = false;
  public deleteService = {
    row: 0,
    id: ''
  };

  async mounted() {
    await this.Loading(true);
    await this.getMemberById(this.$route.params.id);
    this.MemberData = await this.memberInitState.profile;
    await this.getService();
    this.serviceList = this.serviceState.service;
    await this.findData();
    this.getData = true;
    await this.Loading(false);
  }

  async findData() {
    this.MemberData.memberServices.find((main) => {
      this.serviceList.find((service) => {
        if (service.subServices.filter((sub) => sub.id === main.subServiceId).length > 0) {
          main.serviceId = service.subServices.filter((sub) => sub.id === main.subServiceId)[0].serviceId
        }
      })
    })
  }

  addService() {
    let newRow = {
      subServiceId: '',
      serviceId: '',
      memberServiceType: MemberServiceType.ServiceReceiver,
      crossBranch: false,
      memberServiceFreeTimes: [
        {freeDay: '1', use: true},
        {freeDay: '2', use: true},
        {freeDay: '3', use: true},
        {freeDay: '4', use: true},
        {freeDay: '5', use: true},
        {freeDay: '6', use: true},
        {freeDay: '7', use: true},
      ] as MemberServiceFreeTime[]
    } as MemberService;
    this.MemberData.memberServices.push(newRow)
  }

  async delService(row: number, id: string) {
    this.$bvModal.show('service-delete');
    this.deleteService.id = id;
    this.deleteService.row = row;
  }


  showName(day: string) {
    switch (day) {
      case '1': {
        return 'วันอาทิตย์';
      }
      case '2': {
        return 'วันจันทร์';
      }
      case '3': {
        return 'วันอังคาร';
      }
      case '4': {
        return 'วันพุธ';
      }
      case '5': {
        return 'วันพฤหัสบดี';
      }
      case '6': {
        return 'วันศุกร์';
      }
      case '7': {
        return 'วันเสาร์';
      }
      default: {
        return '';
      }
    }
  }

  actionSetValueSub(e: { index: number, subServiceId: string }) {
    this.MemberData.memberServices[e.index].subServiceId = e.subServiceId;
  }

  async saveService() {
    await this.Loading(true);
    let memberData = JSON.parse(JSON.stringify(this.MemberData)) as Member;
    await memberData.memberServices.forEach((x) => delete x.serviceId);
    delete memberData.createdBy;
    delete memberData.modifiedBy;
    delete memberData.deletedBy;
    delete memberData.createdAt;
    delete memberData.modifiedAt;
    delete memberData.deletedAt;
    delete memberData.personEmergencies;
    // @ts-ignore
    delete memberData.community;
    // @ts-ignore
    delete memberData.bondsman;
    // @ts-ignore
    delete memberData.branch;

    let resMember = await this.updateMemberServices(memberData);
    let stats = JSON.parse(JSON.stringify(resMember)).data as ResponseCode;
    if (stats.appCode === 20002) {
      this.Toast({
        message: 'แก้ข้อมูลบริการเรียบร้อยแล้ว',
        heading: 'บันทึกข้อมูลสำเร็จ',
        type: 'success',
      });
      this.$router.push('/profile').then();
      await this.Loading(false)
    } else {
      this.Toast({
        message: 'กรุณาลองใหม่อีกครั้ง',
        heading: 'แก้ข้อมูลบริการไม่สำเร็จ',
        type: 'warning',
      });
      await this.Loading(false)
    }
  }


  close() {
    this.$bvModal.hide('service-delete');
  }

  async everyDay(e: boolean, index:number) {
    if(e) {
      this.MemberData.memberServices[index].memberServiceFreeTimes.forEach((x) => x.use = true);
    }else {
      this.MemberData.memberServices[index].memberServiceFreeTimes.forEach((x) => x.use = false);
    }
  }

  async submitAnswerService() {
    await this.Loading(true);
    this.MemberData.memberServices.splice(this.deleteService.row,1);
    if(this.deleteService.id === undefined) {
      await this.Loading(false)
    }else {
      let resMember = await this.deleteMemberService(this.deleteService.id);
      let stats = JSON.parse(JSON.stringify(resMember)).data as ResponseCode;
      if (stats.appCode === 20002) {
        this.Toast({
          message: 'ลบบริการเรียบร้อยแล้ว',
          heading: 'บันทึกข้อมูลสำเร็จ',
          type: 'success',
        });
        await this.getMemberById(this.$route.params.id);
        this.MemberData = await this.memberInitState.profile;
        await this.Loading(false)
      } else {
        this.Toast({
          message: 'กรุณาลองใหม่อีกครั้ง',
          heading: 'ลบบริการไม่สำเร็จ',
          type: 'warning',
        });
      }
      await this.Loading(false)
    }
    this.$bvModal.hide('service-delete');
    this.deleteService = {
      row: 0,
      id: ''
    };
  }

}
